function initRevealCards(scope = document) {
  const items = scope.querySelectorAll('[data-reveal-card]:not([data-reveal-init])');

  if (!items.length) {
    console.log('[Reveal] nessuna card trovata');
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.remove('opacity-0', 'translate-y-12');
      entry.target.classList.add('opacity-100', 'translate-y-0');

      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  items.forEach((item) => {
    item.dataset.revealInit = 'true';
    observer.observe(item);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initRevealCards();
});

document.addEventListener('shopify:section:load', (event) => {
  initRevealCards(event.target);
});

document.addEventListener('cart:updated', () => {
  initRevealCards();
});